import './styles.css';
import { ParticleFieldApp, showStaticFallback } from './app';

const forceFallback =
  new URLSearchParams(window.location.search).get('forceFallback') === '1';

if (forceFallback) {
  showStaticFallback();
} else {
  try {
    new ParticleFieldApp();
  } catch (error) {
    showStaticFallback(error instanceof Error ? error.message : String(error));
  }
}
